import React from "react";
import PolicyPage from "./PolicyScreen";

export default function PrivacyPolicyPage() {
  return <PolicyPage kind="privacy" />;
}
